import React from "react";
import styled from "styled-components";
import PropTypes from 'prop-types';
const LOGIN_BANNER_URL = 'https://www.se.com/ww/confsdl/msx-front/images/login-banner.png';
const MYSCHNEIDER_SUBLABEL = 'mySchneider';
const MYSCHNEIDER_SPAN_CONTENT = "<span style='color: #3DCD58;'>mySchneider</span>";

const Wrapper = styled.div`
  font-family: inherit;
  background-image: url(${LOGIN_BANNER_URL});
  background-size: 100%;
  margin: 0px;
  flex: 1 1 0px;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: none;
  }
`;

const LoginWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin: 0;
  padding: 0px 35px;
`;

const FixedLoginWrapper = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 0px;
  left: ${(props) => props.left || 0}px;
  width: ${(props) => props.width || 0}px;
  background-image: url(${LOGIN_BANNER_URL});
  background-size: 100%;
  background-color: rgba(0, 0, 0, 0.4);

  @media (max-width: 1000px) {
    background-size: 100% ${props => props.height && `${props.height}px`};
  }
`;

const LoginText = styled.span`
  font-weight: 700;
  font-size: 32px;
  color: white;
  margin-bottom: 10px;
  text-align: center;
  text-align: left;
  line-height: 1.5;
  white-space: pre-wrap;
`;


const LoginSubTitle = styled.span`
  color: white;
  text-align: left;
  font-weight: 400;
  font-size: 20px;
`;

const SubTitleWrapper = styled.div`
  display: flex;
  background-color: rgba(0, 0, 0, 0.4);
  margin: 0;
  padding: 0px 35px;
`;

const StyledList = styled.ul`
  list-style-type: disc;
  padding-left: 24px;
`;

const StyledListItem = styled.li`
  margin-bottom: 10px;
  text-align: left;
`;

class LoginBanner extends React.Component {

  static propTypes = {
    mySchneiderLink: PropTypes.string,
    getLabel: PropTypes.func,
    mobileBreakpoint: PropTypes.number
  }

  constructor(props) {
    super(props);
    this.state = {
      showSticky: false,
      left: 0,
      width: 0,
      height: 0
    };
  }

  componentDidMount = () => {
    setInterval(() => {
      if (this._wrapperElement) {
        const rect = this._wrapperElement.getBoundingClientRect();

        let newState;
        let left = rect.left;
        let width = rect.width;
        if (
          rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight)
        ) {
          newState = false;
        } else {
          newState = true;
        }

        // Fixed element width should match the width of the unfixed
        if (
          this.state.showSticky !== newState ||
          this.state.left !== left ||
          this.state.width !== width
        ) {
          this.setState({ showSticky: newState, left, width});
        }
      }

      // To match the image from the sticky component to the image of the container element.
      if (this._containerElement) {
        const rect = this._containerElement.getBoundingClientRect();
        let height = rect.height;

        if (this.state.height !== height) {
          this.setState({ height });
        }
      }
    }, 10);
  };

  setContainerRef = (element) => {
    this._containerElement = element;
  }

  setWrapperRef = (element) => {
    this._wrapperElement = element;
  };

  render = () => {
    return (
      <Wrapper ref={this.setContainerRef} mobileBreakpoint={this.props.mobileBreakpoint}>
        {this.state.showSticky && (
          <FixedLoginWrapper left={this.state.left} width={this.state.width} height={this.state.height}>
            <LoginWrapper>
              <LoginText dangerouslySetInnerHTML={{ __html: (this.props.getLabel("login.title") || '').replace(MYSCHNEIDER_SUBLABEL, MYSCHNEIDER_SPAN_CONTENT) }}>
              </LoginText>
              <qds-button
                size="large"
                importance="emphasized"
                text={this.props.getLabel("app.action.login_register")}
                onClick={() => {
                  document.location.href = this.props.mySchneiderLink;
                }}
              ></qds-button>
            </LoginWrapper>
          </FixedLoginWrapper>
        )}
        <LoginWrapper ref={this.setWrapperRef}>
          <LoginText dangerouslySetInnerHTML={{ __html: (this.props.getLabel("login.title") || '').replace(MYSCHNEIDER_SUBLABEL, MYSCHNEIDER_SPAN_CONTENT) }}>
          </LoginText>
            <qds-button
              size="large"
              importance="emphasized"
              text={this.props.getLabel("app.action.login_register")}
              onClick={() => {
                document.location.href = this.props.mySchneiderLink;
              }}
            ></qds-button>
        </LoginWrapper>
        <SubTitleWrapper>
          <LoginSubTitle>
            <StyledList>
              <StyledListItem>{this.props.getLabel("login.subtitle.create_projects")}</StyledListItem>
              <StyledListItem>{this.props.getLabel("login.subtitle.access_configurations")}</StyledListItem>
              <StyledListItem>{this.props.getLabel("login.subtitle.get_experts")}</StyledListItem>
            </StyledList>
        </LoginSubTitle>
        </SubTitleWrapper>
      </Wrapper>
    );
  };
}
export default LoginBanner;
